import { useMutation } from '@tanstack/react-query';
import { updateTrack } from '../../../resources/payload';
import { openAlert } from '../../../components/alert/hooks';
import { POST, POST_SCAN_DELIVERY } from '../../../services';

export const useUpdateTracking = () =>
  useMutation({
    mutationFn: async (values) => {
      const payload = values.map((item) => updateTrack(item));

      const response = await POST(POST_SCAN_DELIVERY(), payload);
      return response;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'บันทึกข้อมูลสำเร็จ',
      });
    },
    onError: (err) => {
      openAlert({
        model: 'message',
        type: 'error',
        message: err?.message || 'เกิดข้อผิดพลาดในการบันทึกข้อมูล',
      });
    },
  });
